import { tw } from '@/utils/tw';
import BaseRichTextBox from 'base/components/RichTextBox/theme';

const RichTextBox = tw.theme({
  extend: BaseRichTextBox,
  base: ['mx-auto', 'max-w-content', 'p-grid-m', 'rounded-2xl', 'group-[:not(.bg)]/box:bg-white'],
});

export default RichTextBox;
